import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('InvoiceTemplateInfo', InvoiceTemplateInfoData);

    InvoiceTemplateInfoData.$inject = ['InvoiceTemplate'];

    /* @ngInject */
    function InvoiceTemplateInfoData(InvoiceTemplate) {
        InvoiceTemplateInfo.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getAttByCategory: getAttByCategory,
            getAttBySection: getAttBySection
        };

        function InvoiceTemplateInfo(invoiceTemplateInfoData) {
            if (!invoiceTemplateInfoData) {
                this.buildEmpty();
            } else {
                this.build(invoiceTemplateInfoData);
            }
        }

        return InvoiceTemplateInfo;

        /////////////////////

        function buildEmpty() {
            this.invoiceTemplate = new InvoiceTemplate();
            this.specificTemplate = null;
        }

        function build(invoiceTemplateInfoData) {
            this.invoiceTemplate = new InvoiceTemplate(invoiceTemplateInfoData.invoiceTemplate);
            this.specificTemplate = invoiceTemplateInfoData.specificTemplate;
        }

        function getAttByCategory(category) {
            if (this.invoiceTemplate) {
                return this.invoiceTemplate.getAttByCategory(category);
            }
            return [];
        }

        function getAttBySection(section) {
            if (this.invoiceTemplate) {
                return this.invoiceTemplate.getAttBySection(section);
            }
            return [];
        }
    }
})();
